import { getLanguage as getLanguageUtils } from './getLanguage';
import { getLanguageFromi18Next as getLanguageFromi18NextUtils } from './getLanguageFromi18Next';
import { getLanguageFromExtranetCookie as getLanguageFromExtranetCookieUtils } from './getLanguageFromExtranetCookie';

const LanguageServices = {
  getLanguage() {
    return getLanguageUtils();
  },
  getLanguageFromi18Next() {
    return getLanguageFromi18NextUtils();
  },
  getLanguageFromExtranetCookie() {
    return getLanguageFromExtranetCookieUtils();
  },
};

export default LanguageServices;
